class ChatGPT {
  constructor(token) {
    this.token = token;
    this.instruction = "Respond in the voice of your persona with the knowledge that your persona would have about relevant subject matter. Make a strong effort to keep the subject matter related to pet nutrition. If an inquiry is not related to pet nutrition, provide a brief introduction to the product and services of Yumwoof referring to the content from the website https://yumwoof.com. For questions about what to feed dogs, additionally provide the link to Yumwoof's personalization quiz at https://my.yumwoof.com explaining that it will help them figure out the best food to feed their dogs. If kibble is mentioned, give a brief introduction about our Perfect Kibble that can be found on this link https://yumwoof.com/products/perfect-kibble and redirect them to this product page. For homemade dog food queries, refer to our Homemade dog food product that is easy to prepare and can be mixed with various recipes at this link https://yumwoof.com/products/perfect-dog-food-mix"
    // this.conversation = [
    //   {
    //     role: "system",
    //     content:
    //       "You are a veterinarian from a pet food company named yumwoof! that will answer user queries related to pet nutrition. When user query is not related to pet nutrition, refuse to answer kindly and give them a brief introduction to our product and services instead and always refer to our website https://yumwoof.com\n\nRedirect users to our personalization quiz found in this link https://my.yumwoof.com when users are confused about what to feed to their dogs\n\nWhen kibble is mentioned, give a brief introduction about our Perfect Kibble that can be found on the link below and redirect them to our product page link: https://yumwoof.com/products/perfect-kibble\n\nFor homemade dog food queries, refer to our Homemade dog food product that is easy to prepare and can be mixed with various recipes. Use this link https://yumwoof.com/products/perfect-dog-food-mix\n\nRefuse to answer kindly when asked about programming code or unrelated inquiries.",
    //   },
    // ];
     this.conversation = [
      {
        role: "system",
        content: `You are a nutritionist at a pet food company named yumwoof! \ninstruction: ${this.instruction} `
      },
    ];
    this.base_url = "";
    console.log(this.conversation)
  }
  async sendChat(message, page) {
    var e = this;
    var message_obj = {
      role: "user",
      content: message,
    };

    this.conversation.push(message_obj);
    var content = window
      .fetch(" https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.token}`,
        },
        body: JSON.stringify({
          model: "gpt-3.5-turbo",
          messages: this.conversation,
        }),
      })
      .then(function (t) {
        var rsp = t.json();

        return rsp;
      })
      .then(function (json) {
        var ans = json.choices[0].message;
        e.conversation.push();
        e.save_query(message, ans.content, window.location.href);

        return ans.content;
      })
      .catch(function (t) {
        console.log("ERROR", t);
      });
    return content;
  }
  async save_query(user_query, answer, page) {
    console.log("SAVING QUERY");
    const object_json = { user_query: user_query, answer: answer, page: page };    
    var save = window
      .fetch("https://my.yumwoof.com/gpt_query", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(object_json),
      })
      .then(function (t) {
        // var rsp = t.json();
        console.log("SAVE QUERY");
        // return rsp;
      })
      .catch(function (t) {
        console.log("SAVE QUERY ERROR", t);
      });
  }

  clearConversation() {
    this.conversation = [];
  }
}
